import script from "./Compare.vue?vue&type=script&setup=true&lang=ts"
export * from "./Compare.vue?vue&type=script&setup=true&lang=ts"

import "./Compare.vue?vue&type=style&index=0&id=1e4421fd&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e4421fd"]])

export default __exports__